import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { API_URL } from "../constant";
import { App } from "../firebase";

const PriseRDV = () => {
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [cartId, setCartId] = React.useState(null);
  const [userId, setUserId] = React.useState(null);
  const [productStaffs, setProductStaffs] = React.useState(null);
  const [date, setDate] = React.useState(null);
  const [availabilities, setAvailabilities] = React.useState(null);
  const [availabilitiesRef, setAvailabilitiesRef] = React.useState(null);
  const [schedule, setChedule] = React.useState(null);
  const [newDate, loadNewDate] = React.useState(false);
  const [ncart, setnCart] = React.useState(null);
  const [sticky, setSticky] = React.useState(false);

  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    var navbar = document.getElementById("navbarbb");
    var sticky = navbar.offsetTop;
    const onScroll = () => {
      if (window.pageYOffset >= sticky + (size.width > 800 ? 0 : 150)) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };
    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  React.useEffect(() => {
    if (!sticky) {
      prep(ncart);
    }
  }, [sticky]);

  React.useEffect(() => {
    App.auth().onAuthStateChanged((u) => {
      if (u && id !== null && id !== "remove") {
        addToCart(u);
      }
    });
  }, [id]);

  const [professionnel, setProfessionnel] = React.useState(
    history.location.state
  );

  const [prestations, setPrestations] = React.useState([]);

  function loadPrestation(proid = null, cb) {
    setLoading(true);
    fetch(API_URL + "prestations", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: proid,
        prestataire: true,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.success) {
          var d = data.prestataire;
          d.prestations = data.data;
          setProfessionnel(d);
          cb(d);
        } else {
          alert("Réessayer plus tard");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        alert("Réessayer plus tard");
      });
  }

  const updateCartInfo = (productId, staffId, cart, user) => {
    fetch(API_URL + "cart", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cartId: cart,
        userId: user,
        productId: productId,
        staffId: staffId,
      }),
    })
      .then(() => {
        var d = (date && date[0]) || new Date();
        updateAvailabilities(d);
      })
      .catch((err) => {
        console.log(err);
        // alert("une erreur s'est produite");
      });
  };

  const prepareSelect = (products, proid = null, prestab = null, cart) => {
    var prestas = [];
    var pres =
      (professionnel && professionnel.prestations) ||
      (prestab && prestab.prestations);
    if (pres) {
      products.map((d) => {
        Object.keys(pres).map((keyName) => {
          pres[keyName].map((p) => {
            if (d.productId === p.id) {
              let pro = p;
              pro.staff = d.staff;
              prestas.push(pro);
            }
          });
        });
      });
    } else {
      loadPrestation(proid, (p) => {
        prepareSelect(products, proid, p, cart);
      });
      return;
    }

    setPrestations(prestas);
    setnCart(cart);
    prep(cart);
  };

  const prep = (cart) => {
    setTimeout(() => {
      var x, i, j, l, ll, selElmnt, a, b, c;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName("custom-select");
      l = x.length;
      for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < ll; j++) {
          /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
          c = document.createElement("DIV");
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.addEventListener("click", function (e) {
            /*when an item is clicked, update the original select box,
        and the selected item:*/
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                // console.log(
                //   "staffId : " + s.options[i].value,
                //   "productID : " + s.attributes.id.nodeValue,
                //   h.innerHTML
                // );
                // alert(cart);
                updateCartInfo(
                  s.attributes.id.nodeValue,
                  s.options[i].value,
                  cart,
                  App.auth().currentUser.uid
                );
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                break;
              }
            }
            h.click();
          });
          b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
          /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
      }
      function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
  except the current select box:*/
        var x,
          y,
          i,
          xl,
          yl,
          arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i);
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }
      /*if the user clicks anywhere outside the select box,
then close all select boxes:*/
      document.addEventListener("click", closeAllSelect);
    }, 0);
  };

  function convertDateObj(hhmmss) {
    let obj = new Date(); //creates a Date Object using the clients current time

    let [hours, minutes] = hhmmss.split(":");

    obj.setHours(+hours); // set the hours, using implicit type coercion
    obj.setMinutes(minutes); //you can pass Number or String, it doesn't really matter
    obj.setSeconds(0);
    return obj;
  }

  const prepareRefAvailabilities = (avail) => {
    var lepluslong = [];
    Object.keys(avail).map((keyName) => {
      avail[keyName].forEach((k) => {
        if (!lepluslong.includes(k)) lepluslong.push(k);
      });
    });
    const d = lepluslong.sort((a, b) => convertDateObj(a) - convertDateObj(b)); // Ascending order

    setAvailabilitiesRef(d);
  };

  const updateAvailabilities = (da) => {
    loadNewDate(true);
    // console.log("d", da);
    fetch(API_URL + "cart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        prosId: professionnel && professionnel.id,
        userId: userId || App.auth().currentUser.uid,
        productId: id,
        availabilities: da,
      }),
    })
      .then((res) => res.json())
      .then(async (data) => {
        if (data.success) {
          var n = new Date(da);
          var arrayDate = [new Date(da)];
          for (let index = 0; index < 6; index++) {
            let d = new Date(n.setDate(n.getDate() + 1));
            arrayDate.push(d);
          }

          setDate(arrayDate);
          setAvailabilities(data.availabilities);
          prepareRefAvailabilities(data.availabilities);
          prepareSelect(
            data.cart.products,
            data.cart.prosId,
            null,
            data.cart.id
          );
          loadNewDate(false);
        } else {
          loadNewDate(false);
        }
      })
      .catch((err) => {
        loadNewDate(false);
        console.log(err);
        // alert("une erreur s'est produite");
      });
  };

  const addToCart = (user, pro2 = null) => {
    var s = new Date();
    // alert(s.getHours()> 17); il est déja 18 heure on passe a demain

    s.setHours(0);
    s.setMinutes(0);
    s.setSeconds(0);

    setUserId(user.uid);
    if ((professionnel && professionnel.id) || (pro2 && pro2.id)) {
      let userId = user.uid;
      setLoading(true);
      //ajouter au panier de l'utilisateur connecté
      fetch(API_URL + "cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prosId: (professionnel && professionnel.id) || (pro2 && pro2.id),
          userId: userId || user.uid,
          productId: id,
          availabilities: s,
        }),
      })
        .then((res) => res.json())
        .then(async (data) => {
          setLoading(false);
          if (data.success) {
            var n = new Date();
            var arrayDate = [new Date()];
            for (let index = 0; index < 6; index++) {
              let d = new Date(n.setDate(n.getDate() + 1));
              arrayDate.push(d);
            }
            setDate(arrayDate);
            // const das = await getState(setDate);
            // setFirstDate(das[0]);
            setAvailabilities(data.availabilities);
            prepareRefAvailabilities(data.availabilities);
            setChedule(data.schedule);
            setProductStaffs(data.productStaffs);
            // console.log("data", data);
            setCartId(data.cart.id);
            prepareSelect(
              data.cart.products,
              data.cart.prosId,
              null,
              data.cart.id
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } else {
      // console.log("genre ici");
      setLoading(true);
      fetch(API_URL + "prosbyproduct", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setLoading(false);
            setProfessionnel(data.prestataire);
            setTimeout(() => {
              let u = App.auth().currentUser;
              if (id !== null && id !== "remove") {
                addToCart(u, data.prestataire);
              }
            }, 0);
          } else {
            setLoading(false);
            alert("La prestation n'est plus disponible ou n'éxiste pas.");
            window.location.href = "/";
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  };

  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      prep(ncart);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const save = (date, hour) => {
    setLoading(true);
    var d = date;
    const h = hour.split(":");
    d.setHours(h[0]);
    d.setMinutes(h[1]);
    d.setSeconds(0);
    // alert(cartId);
    //enregistrer les prestations actuellement selectionné
    fetch(API_URL + "prepaid", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cartId: cartId,
        userId: userId,
        date: date,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          history.push({
            pathname: "/recapitulatif",
            state: {
              cart: data.cart,
              professionnel: professionnel,
              productStaffs: productStaffs,
            },
          });
        } else {
          setLoading(false);
          alert(
            "Une erreur s'est produite, réessayer plus tard, si cela persiste contactez nous."
          );
          window.location.reload();
        }
      })
      .catch((err) => {
        setLoading(false);
        alert(
          "Une erreur s'est produite, réessayer plus tard, si cela persiste contactez nous."
        );
        console.log(err);
        window.location.reload();
      });
    //
  };

  const deletePrestation = (item) => {
    //supprimer du tableau des prestations
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Supprimer cette prestation ?")) {
      delThis(item.id);
    }
  };

  const delThis = (productId) => {
    setLoading(true);
    fetch(API_URL + "productToCart", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        productId: productId,
        cartId: cartId,
        userId: userId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          if (id == productId && data.newcart.products.length > 0) {
            data.newcart.products.forEach((e) => {
              if (e.productId) {
                history.push({
                  pathname: "/prise-de-rendez-vous/" + e.productId,
                  state: professionnel,
                });
                return;
              }
            });
          } else {
            if (data.newcart.products.length === 0) {
              history.replace({
                pathname: "/prise-de-rendez-vous/remove",
                state: professionnel,
              });
              setPrestations([]);
              setLoading(false);
              return;
            }
          }
          setLoading(false);
          prepareSelect(
            data.newcart.products,
            data.newcart.prodId,
            null,
            data.newcart.id
          );
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    if (rhours > 0) {
      return rhours + "h " + rminutes + " min.";
    } else {
      return num + " min.";
    }
  }

  const Prestat = ({ item }) => {
    var datauser = {};
    // console.log("ici", item);
    if (item.staff) {
      productStaffs.map((p) => {
        if (p.productId === item.id) {
          p.staffs.map((u) => {
            if (item.staff == u.staffId) {
              datauser = u;
            }
          });
        }
      });
    }
    return (
      <div className="content-bloc" style={{ width: "100%" }}>
        <div
          className="content-sha"
          style={{ padding: "10px 30px", overflow: "visible" }}
        >
          <div
            class="row"
            style={{ flexDirection: size.width <= 830 && "column" }}
          >
            <div
              class="col-50"
              style={{
                alignContent: "center",
                margin: size.width > 830 ? "auto" : "35px 0px",
              }}
            >
              <p
                className="raleway-normal-silver-18px "
                style={{ fontSize: size.width <= 428 && "15px" }}
              >
                {item.name} - {timeConvert(item.time)} -{" "}
                {(item.price / 100).toFixed(2)}€
              </p>
            </div>
            <div
              class="col-31"
              style={{
                display: size.width > 428 && "flex",
                margin: size.width > 830 && "auto",
              }}
            >
              {/* <p>{datauser.uid}</p> */}
              <div
                class="custom-select raleway-bold-black-13px"
                style={{
                  width: 140,
                  backgroundColor: "#fff",
                  border: "2px solid black",
                  borderRadius: 10,
                  display: "flex",
                  marginRight: 38,
                  marginBottom: size.width <= 428 && 20,
                }}
              >
                <select id={item.id}>
                  {datauser && datauser.staffId ? (
                    <option value={datauser.staffId}>
                      {datauser.prenom ||
                        datauser.name ||
                        datauser.email.split("@")[0]}
                    </option>
                  ) : (
                    <option value="0">Choisir avec qui</option>
                  )}
                  {productStaffs.map((e) => {
                    if (e.productId === item.id) {
                      return e.staffs.map((user) => {
                        return (
                          <option value={user.staffId}>
                            {user.prenom ||
                              user.name ||
                              user.email.split("@")[0]}
                          </option>
                        );
                      });
                    }
                  })}
                </select>
              </div>
              <a
                onClick={() => deletePrestation(item)}
                className="raleway-normal-black-16px "
                style={{
                  fontSize: "16px",
                  alignSelf: "center",
                }}
              >
                <u>Supprimer</u>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getDay = (d) => {
    return d.toLocaleString("fr-Fr", {
      weekday: "short",
    });
  };

  const getMonth = (m) => {
    return (
      m
        .toLocaleString("fr-Fr", {
          month: "short",
        })
        .charAt(0)
        .toUpperCase() +
      m
        .toLocaleString("fr-Fr", {
          month: "short",
        })
        .slice(1)
    );
  };

  const calcHP = (start, end, sch) => {
    var r =
      sch[getDay(end).slice(0, -1)][sch[getDay(end).slice(0, -1)].length - 1];
    if (start != r) {
      var sr = start.split(":");
      // var ed = r.split(":");
      var ed = ["17", "30"];
      var s = new Date();
      s.setHours(sr[0]);
      s.setMinutes(sr[1]);
      s.setMinutes(s.getMinutes() + 30);
      s.setSeconds(0);
      var e = new Date();
      e.setHours(ed[0]);
      e.setMinutes(ed[1]);
      e.setMinutes(e.getMinutes() - 30);
      e.setSeconds(0);
      for (var arr = []; s <= e; s.setMinutes(s.getMinutes() + 30)) {
        var ss =
          (s.getHours() <= 9 ? "0" + s.getHours() : s.getHours()) +
          ":" +
          (s.getMinutes() == 0 ? "00" : s.getMinutes());
        // console.log(ss);
        arr.push(ss);
      }
    }
    return arr;
  };

  const CALP = () => {
    return <></>;
    // const d = calcHP(availabilitiesRef.slice(-1)[0], date[0], schedule).map(
    //   (m) => {
    //     return m;
    //   }
    // );
    console.log(availabilitiesRef);
    console.log(date[0]);
    console.log(schedule);
    return (
      <>
        {availabilities && availabilitiesRef != null && schedule && date && (
          <>
            <>
              <span
                style={{
                  color: "gray",
                  opacity: 0.3,
                }}
              >
                {/* {d} */}
                ----
              </span>
              <br />
              <br />
            </>
          </>
        )}
      </>
    );
  };

  const getIfShowArrowBack = () => {
    if (
      date &&
      date[0] &&
      date[0].toLocaleString("fr-FR", {
        dateStyle: "short",
      }) ===
        new Date().toLocaleString("fr-FR", {
          dateStyle: "short",
        })
    ) {
      return false;
    } else {
      return true;
    }
  };

  const getCanselectFirstDay = (hour) => {
    // console.log("11", new Date(), date, firstDate);
    if (
      date &&
      date[0] &&
      date[0].toLocaleString("fr-FR", {
        dateStyle: "short",
      }) ===
        new Date().toLocaleString("fr-FR", {
          dateStyle: "short",
        })
    ) {
      if (
        // new Date().getDate() === firstDate.getDate() &&
        new Date(date[0]).getHours() >
          Number(
            availabilitiesRef[availabilitiesRef.length - 1].split(":")[0]
          ) ||
        new Date(date[0]).getHours() > Number(hour.split(":")[0]) ||
        (new Date(date[0]).getHours() === Number(hour.split(":")[0]) &&
          new Date(date[0]).getMinutes() + 20 > Number(hour.split(":")[1]))
      ) {
        return false;
      }
    }
    return true;
  };

  const getIfAvailabilitiesIsEmpty = () => {
    var hasData = false;
    if (availabilities) {
      for (const [key, value] of Object.entries(availabilities)) {
        availabilities[key].forEach((av) => {
          if (av.length > 0) hasData = true;
        });
      }
    }

    return hasData;
  };

  const canDateAndHour = () => {
    var can = true;
    if (prestations && prestations.length > 0) {
      prestations.forEach((d) => {
        if (d.staff == null && d.staffId == null) {
          can = false;
        }
      });
    }
    console.log("test", can);
    return can;
  };

  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <div class="row" style={{ maxWidth: 784, margin: "60px auto" }}>
        <div
          class="col-75"
          style={{
            margin: size.width <= 428 && "auto",
            // marginLeft: size.width <= 428 && 20,
            // marginRight: size.width <= 428 && 20,
          }}
        >
          {professionnel ? (
            <>
              <div class="container" style={{ padding: 0 }}>
                <h4 className="h4">{professionnel.name}</h4>
                <p
                  className="raleway-medium-dove-18px"
                  style={{ marginTop: 10, marginBottom: 35 }}
                >
                  {professionnel.adresse +
                    " " +
                    professionnel.zipcode +
                    " " +
                    professionnel.city}
                </p>
              </div>
              {loading ? (
                <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
                  <div class="loader" />
                </div>
              ) : (
                <>
                  <div
                    class="container"
                    style={{
                      padding: 0,
                      paddingRight: size.width <= 360 && 16,
                    }}
                  >
                    {prestations.length > 0 && (
                      <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
                        Prestation choisie
                      </div>
                    )}

                    {prestations &&
                      prestations.map((a) => <Prestat item={a} />)}
                  </div>

                  <button
                    class="bouton-plein border-1px-dove-gray"
                    style={{
                      height: size.width <= 428 ? 35 : 55,
                      marginTop: "20px",
                      maxWidth: 332,
                      borderRadius: size.width <= 428 ? 10 : 15,
                    }}
                    onClick={() => {
                      // save();

                      history.push({
                        pathname: "/p/" + professionnel.id,
                        state: professionnel,
                      });
                    }}
                  >
                    <div
                      class="prendre-rdv raleway-semi-bold-white-18px"
                      style={{ fontSize: size.width <= 428 && 15 }}
                    >
                      Ajouter une prestation
                      {prestations.length > 0 ? " à la suite" : ""}
                    </div>
                  </button>

                  <div
                    class="container"
                    style={{
                      paddingTop: "35px",
                      paddingLeft: 0,
                      paddingRight: size.width <= 360 && 16,
                    }}
                  >
                    {prestations &&
                    prestations.length > 0 &&
                    canDateAndHour() ? (
                      <div
                        class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px"
                        id="navbarbb"
                      >
                        Date et heure
                      </div>
                    ) : (
                      <div id="navbarbb" />
                    )}

                    {prestations &&
                      prestations.length > 0 &&
                      !canDateAndHour() && (
                        <>
                          {!newDate ? (
                            <p>
                              Veuillez choisir un employé pour chaque
                              prestations
                            </p>
                          ) : (
                            <div
                              style={{
                                margin: "auto",
                                padding: "60px 0px",
                                width: 55,
                              }}
                            >
                              <div class="loader" />
                            </div>
                          )}
                        </>
                      )}

                    {prestations && prestations.length > 0 && canDateAndHour() && (
                      <>
                        {!newDate ? (
                          <div
                            className="content-bloc"
                            style={{ width: "100%", position: "relative" }}
                          >
                            {availabilities && !getIfAvailabilitiesIsEmpty() ? (
                              <p
                                style={{
                                  textAlign: "center",
                                  position: "relative",
                                  top: 114,
                                }}
                              >
                                Aucun horaire disponible pour la période
                                sélectionnée
                                <br />
                                <a
                                  href="#"
                                  onClick={() => {
                                    if (size.width > 428) {
                                      var d = date[6];
                                    } else {
                                      var d = date[2];
                                    }
                                    d.setDate(d.getDate() + 1);
                                    d.setHours(0);
                                    d.setMinutes(0);
                                    d.setSeconds(0);
                                    updateAvailabilities(d);
                                  }}
                                >
                                  semaine suivante
                                </a>
                              </p>
                            ) : (
                              <div
                                className="divid"
                                style={{ position: "relative", top: 86 }}
                              />
                            )}
                            <div
                              className="content-sha"
                              style={{
                                justifyContent: "center",
                                display: "flex",
                                paddingTop: 27,
                                paddingBottom: 27,
                              }}
                            >
                              <div
                                class="row"
                                style={{
                                  flexDirection: size.width <= 830 && "column",
                                }}
                              >
                                <div
                                  class="grille-de-rptition-7"
                                  // onClick={() => {
                                  //   save();
                                  //   history.push("/recapitulatif");
                                  // }}
                                >
                                  <div
                                    class="arrow-small-left"
                                    style={{
                                      marginRight: size.width <= 428 ? 16 : 30,
                                      marginLeft: size.width <= 428 && 14,
                                      marginTop: 12,
                                      opacity: getIfShowArrowBack() ? 1 : 0.3,
                                      pointerEvents:
                                        !getIfShowArrowBack() && "none",
                                    }}
                                    onClick={() => {
                                      var d = date[0];
                                      d.setDate(d.getDate() - 7);
                                      d.setHours(0);
                                      d.setMinutes(0);
                                      d.setSeconds(0);
                                      updateAvailabilities(d);
                                    }}
                                  />
                                  <div class="groupe-23">
                                    <div class="mar07-dc raleway-bold-silver-18px">
                                      {date && getDay(date[0])}
                                      <br />
                                      {date && date[0].getDate()}{" "}
                                      {date && getMonth(date[0])}
                                    </div>
                                    <div class="text raleway-medium-eerie-black-18px">
                                      {availabilities &&
                                        date &&
                                        date[0] &&
                                        availabilitiesRef &&
                                        availabilitiesRef.map((hour) => {
                                          return (
                                            <>
                                              {/* {console.log(
                                                "ici -- ",
                                                availabilities[
                                                  getDay(date[0]).slice(0, -1)
                                                ]
                                              )} */}
                                              {availabilities[
                                                getDay(date[0]).slice(0, -1)
                                              ].includes(hour) &&
                                              getCanselectFirstDay(hour) ? (
                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                <a
                                                  onClick={() => {
                                                    save(date[0], hour);
                                                  }}
                                                >
                                                  {hour}
                                                </a>
                                              ) : (
                                                <span
                                                  style={{
                                                    color: "gray",
                                                    opacity: 0.3,
                                                    cursor: "not-allowed",
                                                  }}
                                                >
                                                  {hour}
                                                </span>
                                              )}
                                              <br />
                                              <br />
                                            </>
                                          );
                                        })}
                                      <CALP />
                                    </div>
                                  </div>
                                  <div class="groupe-23-1">
                                    <div class="mer08-dc raleway-bold-silver-18px">
                                      {date && getDay(date[1])}
                                      <br />
                                      {date && date[1].getDate()}{" "}
                                      {date && getMonth(date[1])}
                                    </div>
                                    <div class="text raleway-medium-eerie-black-18px">
                                      {availabilities &&
                                        date &&
                                        date[1] &&
                                        availabilitiesRef &&
                                        availabilitiesRef.map((hour) => {
                                          return (
                                            <>
                                              {availabilities[
                                                getDay(date[1]).slice(0, -1)
                                              ].includes(hour) ? (
                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                <a
                                                  onClick={() => {
                                                    save(date[1], hour);
                                                  }}
                                                >
                                                  {hour}
                                                </a>
                                              ) : (
                                                <span
                                                  style={{
                                                    color: "gray",
                                                    opacity: 0.3,
                                                    cursor: "not-allowed",
                                                  }}
                                                >
                                                  {hour}
                                                </span>
                                              )}
                                              <br />
                                              <br />
                                            </>
                                          );
                                          // }
                                        })}
                                      <CALP />
                                    </div>
                                  </div>
                                  <div class="groupe-23-2">
                                    <div class="jeu09-dc raleway-bold-silver-18px">
                                      {date && getDay(date[2])}
                                      <br />
                                      {date && date[2].getDate()}{" "}
                                      {date && getMonth(date[2])}
                                    </div>
                                    <div class="text raleway-medium-eerie-black-18px">
                                      {availabilities &&
                                        date &&
                                        date[2] &&
                                        availabilitiesRef &&
                                        availabilitiesRef.map((hour) => {
                                          return (
                                            <>
                                              {availabilities[
                                                getDay(date[2]).slice(0, -1)
                                              ].includes(hour) ? (
                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                <a
                                                  onClick={() => {
                                                    save(date[2], hour);
                                                  }}
                                                >
                                                  {hour}
                                                </a>
                                              ) : (
                                                <span
                                                  style={{
                                                    color: "gray",
                                                    opacity: 0.3,
                                                    cursor: "not-allowed",
                                                  }}
                                                >
                                                  {hour}
                                                </span>
                                              )}
                                              <br />
                                              <br />
                                            </>
                                          );
                                          // }
                                        })}
                                      <CALP />
                                    </div>
                                  </div>
                                  {size.width > 428 && (
                                    <>
                                      <div class="groupe-23-3">
                                        <div class="ven10-dc raleway-bold-silver-18px">
                                          {date && getDay(date[3])}
                                          <br />
                                          {date && date[3].getDate()}{" "}
                                          {date && getMonth(date[3])}
                                        </div>
                                        <div class="text raleway-medium-eerie-black-18px">
                                          {availabilities &&
                                            date &&
                                            date[3] &&
                                            availabilitiesRef &&
                                            availabilitiesRef.map((hour) => {
                                              return (
                                                <>
                                                  {availabilities[
                                                    getDay(date[3]).slice(0, -1)
                                                  ].includes(hour) ? (
                                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                    <a
                                                      onClick={() => {
                                                        save(date[3], hour);
                                                      }}
                                                    >
                                                      {hour}
                                                    </a>
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "gray",
                                                        opacity: 0.3,
                                                        cursor: "not-allowed",
                                                      }}
                                                    >
                                                      {hour}
                                                    </span>
                                                  )}
                                                  <br />
                                                  <br />
                                                </>
                                              );
                                              // }
                                            })}
                                          <CALP />
                                        </div>
                                      </div>
                                      <div class="groupe-23-4">
                                        <div class="sam11-dc raleway-bold-silver-18px">
                                          {date && getDay(date[4])}
                                          <br />
                                          {date && date[4].getDate()}{" "}
                                          {date && getMonth(date[4])}
                                        </div>
                                        <div class="text raleway-medium-eerie-black-18px">
                                          {availabilities &&
                                            date &&
                                            date[4] &&
                                            availabilitiesRef &&
                                            availabilitiesRef.map((hour) => {
                                              return (
                                                <>
                                                  {availabilities[
                                                    getDay(date[4]).slice(0, -1)
                                                  ].includes(hour) ? (
                                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                    <a
                                                      onClick={() => {
                                                        save(date[4], hour);
                                                      }}
                                                    >
                                                      {hour}
                                                    </a>
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "gray",
                                                        opacity: 0.3,
                                                        cursor: "not-allowed",
                                                      }}
                                                    >
                                                      {hour}
                                                    </span>
                                                  )}
                                                  <br />
                                                  <br />
                                                </>
                                              );
                                              // }
                                            })}
                                          <CALP />
                                        </div>
                                      </div>
                                      <div class="groupe-23-5">
                                        <div class="dim12-dc raleway-bold-silver-18px">
                                          {date && getDay(date[5])}
                                          <br />
                                          {date && date[5].getDate()}{" "}
                                          {date && getMonth(date[5])}
                                        </div>
                                        <div class="text raleway-medium-eerie-black-18px">
                                          {availabilities &&
                                            date &&
                                            date[5] &&
                                            availabilitiesRef &&
                                            availabilitiesRef.map((hour) => {
                                              return (
                                                <>
                                                  {availabilities[
                                                    getDay(date[5]).slice(0, -1)
                                                  ].includes(hour) ? (
                                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                    <a
                                                      onClick={() => {
                                                        save(date[5], hour);
                                                      }}
                                                    >
                                                      {hour}
                                                    </a>
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "gray",
                                                        opacity: 0.3,
                                                        cursor: "not-allowed",
                                                      }}
                                                    >
                                                      {hour}
                                                    </span>
                                                  )}
                                                  <br />
                                                  <br />
                                                </>
                                              );
                                              // }
                                            })}
                                          <CALP />
                                        </div>
                                      </div>
                                      <div class="groupe-23-6">
                                        <div class="lun13-dc raleway-bold-silver-18px">
                                          {date && getDay(date[6])}
                                          <br />
                                          {date && date[6].getDate()}{" "}
                                          {date && getMonth(date[6])}
                                        </div>
                                        <div class="text raleway-medium-eerie-black-18px">
                                          {availabilities &&
                                            date &&
                                            date[6] &&
                                            availabilitiesRef &&
                                            availabilitiesRef.map((hour) => {
                                              return (
                                                <>
                                                  {availabilities[
                                                    getDay(date[6]).slice(0, -1)
                                                  ].includes(hour) ? (
                                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                    <a
                                                      onClick={() => {
                                                        save(date[6], hour);
                                                      }}
                                                    >
                                                      {hour}
                                                    </a>
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "gray",
                                                        opacity: 0.3,
                                                        cursor: "not-allowed",
                                                      }}
                                                    >
                                                      {hour}
                                                    </span>
                                                  )}
                                                  <br />
                                                  <br />
                                                </>
                                              );
                                              // }
                                            })}
                                          <CALP />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  <div
                                    class="arrow-small-right"
                                    style={{
                                      marginLeft: size.width <= 428 && 16,
                                      marginRight: size.width <= 428 && 14,
                                      backgroundColor: "white",
                                      pointerEvents: "visible",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (size.width > 428) {
                                        var d = date[6];
                                      } else {
                                        var d = date[2];
                                      }
                                      d.setDate(d.getDate() + 1);
                                      d.setHours(0);
                                      d.setMinutes(0);
                                      d.setSeconds(0);
                                      updateAvailabilities(d);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            {sticky && (
                              <div
                                style={{
                                  position: sticky && "absolute",
                                }}
                              >
                                <div
                                  className="content-sha stickyb"
                                  style={{
                                    justifyContent: "center",
                                    display: "flex",
                                    paddingTop: 27,
                                    paddingBottom: 27,
                                    display: !sticky
                                      ? "none!important"
                                      : "block!important",
                                    boxShadow: size.width < 800 && "none",
                                    marginLeft: size.width < 800 && 10,
                                  }}
                                >
                                  <div
                                    class="row"
                                    style={{
                                      flexDirection:
                                        size.width <= 830 && "column",
                                    }}
                                  >
                                    <div
                                      class="grille-de-rptition-7"
                                      // onClick={() => {
                                      //   save();
                                      //   history.push("/recapitulatif");
                                      // }}
                                    >
                                      <div
                                        class="arrow-small-left"
                                        style={{
                                          marginRight:
                                            size.width <= 428 ? 16 : 30,
                                          marginLeft: size.width <= 428 && 14,
                                          marginTop: 12,
                                          opacity: getIfShowArrowBack()
                                            ? 1
                                            : 0.3,
                                          pointerEvents:
                                            !getIfShowArrowBack() && "none",
                                        }}
                                        onClick={() => {
                                          var d = date[0];
                                          d.setDate(d.getDate() - 7);
                                          d.setHours(0);
                                          d.setMinutes(0);
                                          d.setSeconds(0);
                                          updateAvailabilities(d);
                                        }}
                                      />
                                      <div
                                        class="groupe-23"
                                        style={{ minHeight: 40 }}
                                      >
                                        <div class="mar07-dc raleway-bold-silver-18px">
                                          {date && getDay(date[0])}
                                          <br />
                                          {date && date[0].getDate()}{" "}
                                          {date && getMonth(date[0])}
                                        </div>
                                      </div>
                                      <div
                                        class="groupe-23-1"
                                        style={{ minHeight: 40 }}
                                      >
                                        <div class="mer08-dc raleway-bold-silver-18px">
                                          {date && getDay(date[1])}
                                          <br />
                                          {date && date[1].getDate()}{" "}
                                          {date && getMonth(date[1])}
                                        </div>
                                      </div>
                                      <div
                                        class="groupe-23-2"
                                        style={{ minHeight: 40 }}
                                      >
                                        <div class="jeu09-dc raleway-bold-silver-18px">
                                          {date && getDay(date[2])}
                                          <br />
                                          {date && date[2].getDate()}{" "}
                                          {date && getMonth(date[2])}
                                        </div>
                                      </div>
                                      {size.width > 428 && (
                                        <>
                                          <div
                                            class="groupe-23-3"
                                            style={{ minHeight: 40 }}
                                          >
                                            <div class="ven10-dc raleway-bold-silver-18px">
                                              {date && getDay(date[3])}
                                              <br />
                                              {date && date[3].getDate()}{" "}
                                              {date && getMonth(date[3])}
                                            </div>
                                          </div>
                                          <div
                                            class="groupe-23-4"
                                            style={{ minHeight: 40 }}
                                          >
                                            <div class="sam11-dc raleway-bold-silver-18px">
                                              {date && getDay(date[4])}
                                              <br />
                                              {date && date[4].getDate()}{" "}
                                              {date && getMonth(date[4])}
                                            </div>
                                          </div>
                                          <div
                                            class="groupe-23-5"
                                            style={{ minHeight: 40 }}
                                          >
                                            <div class="dim12-dc raleway-bold-silver-18px">
                                              {date && getDay(date[5])}
                                              <br />
                                              {date && date[5].getDate()}{" "}
                                              {date && getMonth(date[5])}
                                            </div>
                                          </div>
                                          <div
                                            class="groupe-23-6"
                                            style={{ minHeight: 40 }}
                                          >
                                            <div class="lun13-dc raleway-bold-silver-18px">
                                              {date && getDay(date[6])}
                                              <br />
                                              {date && date[6].getDate()}{" "}
                                              {date && getMonth(date[6])}
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      <div
                                        class="arrow-small-right"
                                        style={{
                                          marginLeft: size.width <= 428 && 16,
                                          marginRight: size.width <= 428 && 14,
                                          backgroundColor: "white",
                                          pointerEvents: "visible",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          if (size.width > 428) {
                                            var d = date[6];
                                          } else {
                                            var d = date[2];
                                          }
                                          d.setDate(d.getDate() + 1);
                                          d.setHours(0);
                                          d.setMinutes(0);
                                          d.setSeconds(0);
                                          updateAvailabilities(d);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            style={{
                              margin: "auto",
                              padding: "60px 0px",
                              width: 55,
                            }}
                          >
                            <div class="loader" />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
              <div class="loader" />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PriseRDV;
